/* XC カートページ — Ajax数量変更/削除/関連追加。非JS時は標準cart formで動作。 */
(function () {
  'use strict';
  if (window.__xcCartInit) return;
  window.__xcCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var queue = Promise.resolve();
  var debounceTimers = {};

  function page() { return document.querySelector('[data-xc-cartpage]'); }

  function requestJson(url, options, timeoutMs) {
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeoutMs || 12000) : null;
    options = options || {};
    options.credentials = options.credentials || 'same-origin';
    options.cache = options.cache || 'no-store';
    if (controller) options.signal = controller.signal;
    return fetch(url, options).then(function (response) {
      return response.text().then(function (body) {
        var data = {};
        try { data = body ? JSON.parse(body) : {}; } catch (ignore) {}
        if (!response.ok) throw new Error(data.description || data.message || '通信に失敗しました');
        return data;
      });
    }).then(function (data) {
      if (timer) clearTimeout(timer);
      return data;
    }, function (error) {
      if (timer) clearTimeout(timer);
      throw error;
    });
  }

  function requestHtml(url, timeoutMs) {
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeoutMs || 12000) : null;
    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('カート表示を更新できませんでした');
      return response.text();
    }).then(function (html) {
      if (timer) clearTimeout(timer);
      return html;
    }, function (error) {
      if (timer) clearTimeout(timer);
      throw error;
    });
  }

  function releaseBusy(promise) {
    return promise.then(function (value) {
      setBusy(false);
      return value;
    }, function (error) {
      setBusy(false);
      throw error;
    });
  }

  function announce(msg) {
    var live = document.getElementById('xc-cart-live');
    if (!live) {
      live = document.createElement('p');
      live.id = 'xc-cart-live';
      live.className = 'xc-cart-page__status';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  function setBusy(on) {
    busy = on;
    var p = page();
    if (p) { p.classList.toggle('is-busy', on); p.setAttribute('aria-busy', on ? 'true' : 'false'); }
  }

  /* カートHTMLを再取得してページ本体を差し替え(合計・件数・空状態も一括反映) */
  function rerender() {
    return requestHtml(root + 'cart?view=xc', 12000)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-xc-cartpage]');
        var cur = page();
        if (fresh && cur) cur.replaceWith(fresh);
      });
  }

  function refreshBadge(cartData) {
    document.dispatchEvent(new CustomEvent('xc:cart:count', { detail: { count: cartData.item_count } }));
    var badge = document.querySelector('[data-xc-cart-count]');
    if (badge) { badge.textContent = cartData.item_count; badge.hidden = !(cartData.item_count > 0); }
  }

  function changeLine(line, quantity) {
    queue = queue.catch(function () {}).then(function () {
      setBusy(true);
      return releaseBusy(requestJson(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }, 12000)
        .then(function (cartData) {
          refreshBadge(cartData);
          return rerender().then(function () {
            announce('カートを更新しました。合計 ' + cartData.item_count + '点');
          });
        })
        .catch(function (err) {
          announce('更新できませんでした: ' + err.message);
          return rerender().catch(function () {});
        }));
    });
    return queue;
  }

  function addVariant(id) {
    queue = queue.catch(function () {}).then(function () {
      setBusy(true);
      var requestId = window.XCCartEvents && window.XCCartEvents.request();
      return releaseBusy(requestJson(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }, 12000)
        .then(function (result) {
          if (window.XCCartEvents) window.XCCartEvents.success(requestId, result, [{ id: Number(id), quantity: 1 }]);
          return requestJson(root + 'cart.js', { headers: { 'Accept': 'application/json' } }, 12000);
        })
        .then(function (cartData) {
          refreshBadge(cartData);
          document.dispatchEvent(new CustomEvent('xc:cart:added', { detail: { cart: cartData } }));
          return rerender().then(function () { announce('カートに追加しました。'); });
        })
        .catch(function (err) {
          if (window.XCCartEvents) window.XCCartEvents.failure(requestId);
          announce('追加結果を確認できませんでした。カートを確認してから再度お試しください。');
        }));
    });
    return queue;
  }

  /* 委譲イベント(再描画後もそのまま動く) */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-xc-qminus]');
    var plus = e.target.closest('[data-xc-qplus]');
    var remove = e.target.closest('[data-xc-remove]');
    var recAdd = e.target.closest('[data-xc-rec-add]');
    var spCheckout = e.target.closest('[data-xc-spbar-checkout]');

    if (spCheckout) {
      var form = document.querySelector('.xc-cart-page__grid');
      var btn = form && form.querySelector('button[name="checkout"]');
      if (btn && !btn.disabled) btn.click();
      return;
    }
    if (recAdd) {
      e.preventDefault();
      if (busy || recAdd.disabled) return;
      var recCard = recAdd.closest('.xc-sponge-cross-sell__card');
      var recSelect = recCard && recCard.querySelector('[data-xc-rec-variant]');
      if (recSelect) {
        var selected = recSelect.options[recSelect.selectedIndex];
        if (!selected || !selected.value || selected.disabled) { recSelect.focus(); return; }
        addVariant(selected.value);
      } else {
        addVariant(recAdd.getAttribute('data-xc-rec-add'));
      }
      return;
    }
    if (remove) { e.preventDefault(); if (!busy) changeLine(parseInt(remove.getAttribute('data-xc-remove'), 10), 0); return; }
    if (minus || plus) {
      e.preventDefault();
      if (busy) return;
      var item = e.target.closest('[data-xc-line]');
      var input = item && item.querySelector('[data-xc-qinput]');
      if (!input) return;
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
      input.value = q;
      changeLine(parseInt(input.getAttribute('data-xc-line'), 10), q);
    }
  });

  document.addEventListener('change', function (e) {
    var recSelect = e.target.closest('[data-xc-rec-variant]');
    if (recSelect) {
      var recCard = recSelect.closest('.xc-sponge-cross-sell__card');
      var recButton = recCard && recCard.querySelector('[data-xc-rec-add]');
      var recImage = recCard && recCard.querySelector('[data-xc-rec-image]');
      var selected = recSelect.options[recSelect.selectedIndex];
      var valid = !!(selected && selected.value && !selected.disabled);
      if (recButton) recButton.disabled = !valid;
      if (valid && recImage) {
        recImage.srcset = selected.getAttribute('data-xc-rec-image-srcset');
        recImage.src = selected.getAttribute('data-xc-rec-image-src');
        recImage.alt = selected.getAttribute('data-xc-rec-image-alt');
      }
      return;
    }
    var input = e.target.closest('[data-xc-qinput]');
    if (!input) return;
    var line = input.getAttribute('data-xc-line');
    clearTimeout(debounceTimers[line]);
    debounceTimers[line] = setTimeout(function () {
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(line, 10), q);
    }, 300);
  });

  /* Theme Editor: セクション再読込に対応(委譲方式のため再バインド不要) */
  document.addEventListener('shopify:section:load', function () { /* no-op */ });
})();
